import dateTimeFormat from "@/core/filters/dateTimeFormat.filter";
import { AUTH } from "@/core/api";
import {
  LOADING_OPEN_LOADING,
  LOADING_CLOSE_LOADING,
} from "@/core/store/loading.module";
import { jwtHelper, apiHelper } from "@/core/utils";

/* Define Module Name */
const MODULE_NAME = "auth/";

/* Define Action Name */
const A_GET_LOGIN = "getLogin";
const A_GET_TOKEN = "getToken";
const A_GET_PERMISSION = "getPermission";

/* Define Reset State Action Name */
const A_INITIAL_GET_LOGIN_STATE = "initialGetLoginState";
const A_INITIAL_GET_TOKEN_STATE = "initialGetTokenState";
const A_INITIAL_GET_PERMISSION_STATE = "initialGetPermissionState";

/* Define Getter Name */

/* Define Mutation Name */
const M_GET_LOGIN = "setGetLogin";
const M_GET_TOKEN = "setGetToken";
const M_GET_PERMISSION = "setGetPermission";

/* Define Reset State Mutation Name */
const M_INITIAL_GET_LOGIN_STATE = "setInitialGetLoginState";
const M_INITIAL_GET_TOKEN_STATE = "setInitialGetTokenState";
const M_INITIAL_GET_PERMISSION_STATE = "setInitialGetPermissionState";

/* Define Export Name */
export const AUTH_GET_LOGIN = MODULE_NAME + A_GET_LOGIN;
export const AUTH_GET_TOKEN = MODULE_NAME + A_GET_TOKEN;
export const AUTH_GET_PERMISSION = MODULE_NAME + A_GET_PERMISSION;

/* Define Reset State Name */
export const AUTH_INITIAL_GET_LOGIN_STATE =
  MODULE_NAME + A_INITIAL_GET_LOGIN_STATE;
export const AUTH_INITIAL_GET_TOKEN_STATE =
  MODULE_NAME + A_INITIAL_GET_TOKEN_STATE;
export const AUTH_INITIAL_GET_PERMISSION_STATE =
  MODULE_NAME + A_INITIAL_GET_PERMISSION_STATE;

const state = {
  getLogin: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
  getToken: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
  getPermission: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
};

//Getters
const getters = {};

// Actions
const actions = {
  [A_GET_LOGIN]({ dispatch, commit }, {}) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    AUTH.getLogin()
      .then((response) => {
        result = response;
        commit(M_GET_LOGIN, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_GET_LOGIN, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_GET_TOKEN]({ dispatch, commit }, { data }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    AUTH.getToken(data)
      .then((response) => {
        result = response;
        commit(M_GET_TOKEN, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_GET_TOKEN, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_GET_PERMISSION]({ dispatch, commit }, {}) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    AUTH.getPermission()
      .then((response) => {
        result = response;
        commit(M_GET_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_GET_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_INITIAL_GET_LOGIN_STATE]({ commit }) {
    commit(M_INITIAL_GET_LOGIN_STATE);
  },
  [A_INITIAL_GET_TOKEN_STATE]({ commit }) {
    commit(M_INITIAL_GET_TOKEN_STATE);
  },
  [A_INITIAL_GET_PERMISSION_STATE]({ commit }) {
    commit(M_INITIAL_GET_PERMISSION_STATE);
  },
};

// Mutations
const mutations = {
  [M_GET_LOGIN](state, result) {
    if (result.code === 200) {
      let d = result.data;
      state.getLogin = {
        code: result.code,
        complete: true,
        data: {
          url: d.url,
        },
        message: null,
      };
    } else {
      state.getLogin = {
        code: result.code,
        complete: true,
        data: null,
        message: apiHelper.sortOutMessage(result.msg),
      };
    }
  },
  [M_GET_TOKEN](state, result) {
    if (result.code === 200) {
      state.getToken = {
        code: result.code,
        complete: true,
        data: result,
        message: "",
      };
      jwtHelper.setToken(result.data.access_token);
    } else {
      state.getToken = {
        code: result.code,
        complete: true,
        data: result,
        message: apiHelper.sortOutMessage(result.msg),
      };
    }
  },
  [M_GET_PERMISSION](state, result) {
    if (result.code === 200) {
      state.getPermission = {
        code: result.code,
        complete: true,
        data: result,
        message: apiHelper.sortOutMessage(result.msg),
      };
      jwtHelper.setProfile(result.data);
    } else {
      state.getPermission = {
        code: result.code,
        complete: true,
        data: result,
        message: apiHelper.sortOutMessage(result.msg),
      };
    }
  },
  [M_INITIAL_GET_LOGIN_STATE](state) {
    state.getLogin = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
  [M_INITIAL_GET_TOKEN_STATE](state) {
    state.getToken = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
  [M_INITIAL_GET_PERMISSION_STATE](state) {
    state.getPermission = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
